export const TypeSectionData = [
    {
        id: 1,
        Type:"Veg",
        Categories: ["Breakfast","Starter","MainCourse","Rice","Noodles"],
        Img1: "https://media.istockphoto.com/photos/table-top-view-of-indian-food-picture-id1249893854?k=20&m=1249893854&s=612x612&w=0&h=aCb20e8b6LepAjuvAa5qnlDjH1lfgFbVJhVGl9pIWR4=",
        Img2: "https://media.istockphoto.com/photos/table-top-view-of-indian-food-picture-id1212329362?k=20&m=1212329362&s=612x612&w=0&h=C1aG1q3obsP0JdXUU_t1sGvdm46zoDe_QQ7auQmpzTc=",
        Animation1: "fade-right",
        Animation2: "fade-left"
    },
    {
        id: 2,
        Type:"NonVeg",
        Categories: ["Breakfast","Starter","MainCourse","Rice","Tandoori"],
        Img1: "https://media.istockphoto.com/photos/assorted-indian-non-vegetarian-food-recipe-served-in-a-group-includes-picture-id1169700146?k=20&m=1169700146&s=612x612&w=0&h=iuuGcS_3RDBv3qF9dU-E1sswsbzB8nOEUGH7J24JSnA=",
        Img2: "https://media.istockphoto.com/photos/assorted-indian-non-vegetarian-food-recipe-served-in-a-group-includes-picture-id1169704630?k=20&m=1169704630&s=612x612&w=0&h=AuSwqJUhgF1Ipx3YeHfUSIg38Ve2_jaKWzgZgCP-1Qw=",
        Animation1: "fade-left",
        Animation2: "fade-right",
    }
]
